<template>
  <div
    class="page_container goodsManageSet"
    v-loading="loading"
    element-loading-text="请稍后"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)"
  >
    <div class="breadcrumb flex-rowl">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/manage' }"
          >物流&订单管理</el-breadcrumb-item
        >
        <el-breadcrumb-item :to="{ path: '/comSalesIndex/cBacklogList' }"
          >退款申请审核</el-breadcrumb-item
        >
        <el-breadcrumb-item>退款申请详情</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <!--  主要内容 start -->
    <div class="form_container">
      <div class="content_wrap flex-rowl">
        <div class="tip_wrap">
          <div class="item">
            <h1>退款工单号：</h1>
            <p>{{ dataItem.workno }}</p>
          </div>
          <div class="item">
            <h1>订单号：</h1>
            <p>{{ dataItem.orderno }}</p>
          </div>
          <div class="item">
            <h1>创建时间：</h1>
            <p>{{ dataItem.createdate | formatDate }}</p>
          </div>
          <div class="item shop_item">
            <div
              class="block"
              v-for="(item, index) in dataItem.ams_shop_backlog_detail"
              :key="index"
            >
              <h1>
                商品名称：<span>{{ item.commodityname }}</span>
              </h1>
              <!-- <h1>
                商品ID：<span>{{ item.id }}</span>
              </h1> -->
              <h1>
                商品SKU：<span>{{ item.sku }}</span>
              </h1>
              <h1 v-if="item.cbprice">
                成本参考价：<span>¥ {{ item.cbprice }}/件</span>
              </h1>
              <h1 v-if="item.price">
                基础零售价：<span>¥ {{ item.price }}/件</span>
              </h1>
              <h1 v-if="item.pfprice">
                批发参考价：<span>¥ {{ item.pfprice }}/件</span>
              </h1>
              <h1 v-if="item.groupprice">
                基础批发价：<span>¥ {{ item.groupprice }}/件</span>
              </h1>
              <h1>
                <p v-for="(label, labelIndex) in item.attr" :key="labelIndex">
                  <span>{{ label }}</span
                  ><span>：{{ item.attrPrice }}/件</span>
                </p>
              </h1>
              <h1>
                商品数量：<span>{{ item.num }}</span>
              </h1>
              <h1>
                价格小计：<span>{{ item.newPrice }}</span>
              </h1>
            </div>
          </div>
        </div>
        <div class="tip_wrap">
          <div class="item">
            <h1>账户姓名：</h1>
            <p>{{ dataItem.truename }}</p>
          </div>

          <!-- <div class="item">
            <h1>账户id：</h1>
            <p>{{ dataItem.accountid }}</p>
          </div>
          <div class="item">
            <h1>用户手机号：</h1>
            <p>{{ dataItem.mobile }}</p>
          </div> -->
          <div class="item">
            <h1>物流类型：</h1>
            <p>{{ dataItem.service_companystr }}</p>
          </div>
          <div class="item">
            <h1>发货物流单号：</h1>
            <p>{{ dataItem.service_no }}</p>
          </div>
          <!-- <div class="item">
            <h1>是否取消退款：</h1>
            <p>{{ dataItem.iscancel == 1 ? "是" : "否" }}</p>
          </div> -->
          <div class="item">
            <h1>退款属性：</h1>
            <p>{{ dataItem.returnattrstr }}</p>
          </div>
          <div class="item">
            <h1>备注信息：</h1>
            <p>{{ dataItem.talk }}</p>
          </div>
        </div>
        <div class="tip_wrap">
          <div class="item">
            <h1>退款类型：</h1>
            <p>{{ dataItem.logtypestr }}</p>
          </div>
          <div class="item">
            <h1>退款金额：</h1>
            <p>{{ dataItem.fee }}</p>
          </div>
          <div class="item">
            <h1>退款情况：</h1>
            <p>{{ dataItem.returnnotestr }}</p>
          </div>

          <div class="item">
            <h1>退费原因：</h1>
            <p>{{ dataItem.reasonidstr }}</p>
          </div>
          <div class="item">
            <h1>退款状态：</h1>
            <p>{{ dataItem.returnstate }}</p>
          </div>
          <div class="item">
            <h1>退款审核状态：</h1>
            <p>{{ dataItem.checkstatestr }}</p>
          </div>

          <div class="item">
            <h1>退款时间：</h1>
            <p>{{ dataItem.returndate | formatDate }}</p>
          </div>
        </div>
      </div>
    </div>
    <div class="form_footer flex-rowl">
      <div class="btn" :class="{'disabled': dataItem.checkstate == 4 || dataItem.checkstate == 5 }" @click="handleEdit">审批操作</div>
      <div class="return_txt" @click="handleReturn">←返回</div>
    </div>
    <!--  主要内容 end -->
  </div>
</template>

<script>
import { encryptstringview, encryptstringadd } from "../../../api/api";
import { getBacklogDetail } from "../../../api/shop";
import { calculator } from "../../../utils/decimal";
import { mapState } from "vuex";
export default {
  name: "cBacklogDetail",
  data() {
    return {
      loading: false,
      qyid: "",
      dataItem: "",
      type: "",
      id: '',
    };
  },
  filters: {
    // 时间格式化
    formatDate(date) {
      if (!date) return "";
      if (date.indexOf("T") != -1) {
        let dateSplit = date.split("T");
        let dataTime =
          dateSplit[1].indexOf(".") != -1
            ? dateSplit[1].split(".")[0]
            : dateSplit[1];
        return dateSplit[0] + " " + dataTime; // 这里可以根据需要使用不同的日期格式化选项
      } else {
        return date;
      }
    },
  },
  computed: {
    ...mapState(["OPENID"]),
  },
  created() {
    let { routerList, OPENID, USERINFO } = this.$store.state;
    let { name } = this.$route;
    if (USERINFO.qy) {
      this.qyid = USERINFO.qy.qyid;
    } else {
      this.qyid = 0;
    }

    // 判断是有有参数需要解密 this.$route中的name和state.routerList对象
    if (name in routerList) {
      if (routerList[name].encryptstring == "") return;
      this.encryptstringview(routerList[name].encryptstring, OPENID);
    }
  },
  methods: {
    // 通过解密获取参数
    async encryptstringview(encryptstring, openid) {
      let res = await encryptstringview({ openid, encryptstring });
      if (res.result) {
        let { id } = JSON.parse(res.jsondata);
        this.id = id
        this.getBacklogDetail(id);
      } else {
        this.$router.back();
      }
    },

    // 订单列表
    getBacklogDetail(id) {
      this.loading = true;
      getBacklogDetail({ id }).then((res) => {
        if (res.ams_shop_backlog_detail.length > 0) {
          res.ams_shop_backlog_detail.forEach((v1) => {
            v1.attr = JSON.parse(v1.attr);
            // 单件商品总价 (零售价 +/- 标签价) * 数量  后续加入折扣价针对于第一个商品
            let attrPrice =
              v1.attrnumtype == "不变"
                ? 0
                : v1.attrnumtype == "减少"
                ? "-" + v1.attrnum
                : v1.attrnum;

            v1.attrPrice =
              v1.attrnumtype == "不变"
                ? "¥" + 0
                : v1.attrnumtype == "减少"
                ? "- ¥" + v1.attrnum
                : "+ ¥" + v1.attrnum;
            v1.newPrice = calculator(calculator(v1.price).add(attrPrice))
              .multiply(v1.num)
              .toNumber();
          });
        }
        this.dataItem = res;
        this.loading = false;
      });
    },

    handleReturn() {
      this.$router.back();
    },

    handleToast() {
      this.$message.warning("即将开放");
    },

    // 计算商品差价
    shopPriceDifference(price, price1) {
      return calculator(price1).subtract(price).toNumber();
    },

    handleEdit() {
      let {dataItem} = this
      if(dataItem.checkstate == 4 || dataItem.checkstate == 5) {
        return
      }
      this.encryptstringadd("cBacklogEdit", { id: this.id});
    },

      // 页面跳转之前对参数进行加密
    async encryptstringadd(name, params) {
      if (params != "") {
        let paramsData = {
          openid: this.OPENID,
          jsondata: JSON.stringify(params),
        };
        const response = await encryptstringadd(paramsData);
        if (response.result) {
          this.$store.commit("cacheRoute", {
            encryptstring: response.encryptstring,
            name,
          });
          this.$router.push({
            name,
            params,
          });
        }
      } else {
        this.$store.commit("cacheRoute", {
          encryptstring: '',
          name,
        });
        this.$router.push({
          name,
          params,
        });
      }
    },
  },
};
</script>
<style lang="less" scoped>
.page_container {
  .form_container {
    align-items: flex-start;
    flex-flow: wrap;
    .content_wrap {
      .form_wrap {
        margin-right: 100px;
      }
      .tip_wrap {
        flex-shrink: 0;
        width: calc(100% / 3);
        .item {
          margin-bottom: 15px;
          color: #6e6e6e;
          h1 {
            margin-bottom: 8px;
            font-size: 18px;
            white-space: nowrap;
          }
          &.shop_item {
            font-size: 14px;
            h1 {
              font-size: 16px;
              span {
                color: #6e6e6e;
                font-size: 14px;
              }
            }
            .block {
              margin-bottom: 20px;
            }
          }
          p {
            &.red {
              color: red;
            }
          }
          &.pay_item {
            p {
              margin-bottom: 5px;
            }
          }
        }
      }
    }
  }
  .form_footer {
    .btn {
      &.disabled {
         background: #a6a6a6;
      }
    }
  }
}
</style>